import {
    Box,
    Button,
    Typography,
    makeStyles
} from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import PercentageInput from "./PercentageInput";
import {
    Edit as EditIcon,
} from '@material-ui/icons';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { useEffect, useState } from "react";
import { BrandPopover } from "../CoreComponents/BrandPopover";

const useStyles = makeStyles((theme) => ({
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: theme.spacing(2)
    },
    revenueSplitWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    bulkEditButton: {
        color: theme.palette.primary.lightGray,
        fontSize: '12px',
        textTransform: 'capitalize',
        padding: '0px',
        marginLeft: '60%',
        '&:hover': {
            cursor: 'pointer',
            color: theme.palette.primary.main,
            backgroundColor: 'transparent'
        },

    },
    bulkEditInput: {
        marginLeft: '60%',
        display: 'flex',
        alignItems: 'center'
    },
    icon: {
        width: '20px',
        height: '20px',
        marginRight: '5px'
    },
    starIcon: {
        verticalAlign: 'middle'
    },
    bulkEditWrapper: {
        display: 'flex',
        width: '100%',
    },
    accountHolderName: {
        display: 'flex',
        flex: 1
    },
    percentageWrapper: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2)
    },
    deleteIcon: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        cursor: 'pointer',
        color: theme.palette.primary.alert
    }
}));

const EditListRevenueSplits = ({
    revenueSplits,
    mainAccountHolderId,
    setRevenueSplits,
    setDisabledApplyEdit,
    showBulkEdit = false
}) => {
    const [bulkEditValue, setBulkEditValue] = useState('');
    const [showBulkEditField, setShowBulkEditField] = useState(false);
    const [bulkFieldValidator, setBulkFieldValidator] = useState(false);
    const [percentageValidators, setPercentageValidators] = useState([]);

    useEffect(() => {
        const validators = revenueSplits.map((x) => ({ id: x.id, validated: true }));
        setPercentageValidators(validators);
    }, [revenueSplits]);

    useEffect(() => {
        const validationDisableEdit = percentageValidators.some((v) => !v.validated);
        setDisabledApplyEdit(validationDisableEdit);
    }, [percentageValidators]);

    const styles = useStyles();

    const handleShowBulkEditField = () => setShowBulkEditField(true);

    const handlePercentageOnChange = (value, revenueSplitId) => {
        const updatedRevenueSplits = revenueSplits.map((s) =>
            s.id === revenueSplitId ? { ...s, splitPercentage: value } : s
        );

        setRevenueSplits(updatedRevenueSplits);
    }

    const handleBulkEditValueOnChange = (value) => {
        const updatedRevenueSplits = revenueSplits.map((s) => (
            { ...s, splitPercentage: value })
        );

        setBulkEditValue(value);
        setRevenueSplits(updatedRevenueSplits);
    }

    const generateValidatorSetter = (id) => {
        return (value) => setPercentageValidators(
            percentageValidators.map((v) =>
                v.id === id ? { ...v, validated: value } : v
            )
        );
    }

    const generateBulkValidatorSetter = (value) => {
        setBulkFieldValidator(value);
        setPercentageValidators(
            percentageValidators.map((v) => ({ ...v, validated: value }))
        );
    }

    const handleDeleteSplit = (accountHolderId) => {
        setRevenueSplits(prev => prev.filter((s) => s.accountHolderId !== accountHolderId));
    };

    return (
        <Box className={styles.contentWrapper}>
            {showBulkEdit && (
                <Box className={styles.bulkEditWrapper}>
                    {showBulkEditField ? (
                        <Box className={styles.bulkEditInput}>
                            <PercentageInput
                                inputData={bulkEditValue}
                                setInputData={handleBulkEditValueOnChange}
                                validatorPassed={[
                                    bulkFieldValidator,
                                    generateBulkValidatorSetter
                                ]}
                                autoFocus
                            />
                        </Box>
                    ) : (
                        <Button
                            className={styles.bulkEditButton}
                            onClick={handleShowBulkEditField}
                        >
                            <EditIcon className={styles.icon} />
                            Bulk Edit
                        </Button>
                    )}
                </Box>
            )}
            {[...revenueSplits]
            .sort((a, b) => a.accountHolderId === mainAccountHolderId ? -1 : b.accountHolderId === mainAccountHolderId ? 1 : 0)
            .map(({
                id,
                name,
                splitPercentage,
                accountHolderId
            }) => (
                <Box key={id} className={styles.revenueSplitWrapper}>
                    <Typography className={styles.accountHolderName}>
                        {name}
                        {mainAccountHolderId == accountHolderId &&
                            <BrandPopover
                                popoverDataFormated={
                                    <StarIcon
                                        className={styles.starIcon}
                                    />
                                }
                                popoverData={<>Main Account Holder.<br />Cannot be deleted.</>}
                            >
                            </BrandPopover>
                        }
                    </Typography>
                    <Box className={styles.percentageWrapper}>
                        <PercentageInput
                            inputData={splitPercentage}
                            setInputData={(value) => handlePercentageOnChange(value, id)}
                            validatorPassed={[
                                percentageValidators.find((x) => x.id === id),
                                generateValidatorSetter(id)
                            ]}
                        />
                        {accountHolderId != mainAccountHolderId &&
                            <div
                                onClick={() => handleDeleteSplit(accountHolderId)}
                                className={styles.deleteIcon}
                            >
                                <DeleteOutlineOutlinedIcon fontSize='small' />
                                <div>Delete</div>
                            </div>
                        }
                    </Box>
                </Box>
            ))}
        </Box>
    )
}

export default EditListRevenueSplits;